/* Publish by EComposer at 2026-10-21 02:02:20*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-1mj8lcp3ske"]=  window.__ectimmers["ecom-1mj8lcp3ske"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),n=t.querySelector(".text-content.ecom-html");!n||(e&&e.addEventListener("click",()=>{n.classList.remove("ecom-text--is-mark"),n.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{n.classList.add("ecom-text--is-mark"),n.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-1mj8lcp3ske').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1mj8lcp3ske', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-oerskqybsr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-oerskqybsr', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-unixnlptwe').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-unixnlptwe', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3f8dcq6702f').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3f8dcq6702f', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vfko2gvi9c').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vfko2gvi9c', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hteqifem6j').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hteqifem6j', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-74wddb0i32l').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-74wddb0i32l', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qry0e37wlf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qry0e37wlf', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9jx4gc84f3q').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9jx4gc84f3q', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-dem5z889lmp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-dem5z889lmp', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-64cjn061xie').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-64cjn061xie', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4nghbc3i14t').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4nghbc3i14t', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-745k55xdxen').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-745k55xdxen', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-pw8ctkpeck9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pw8ctkpeck9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wa3hlk8ti8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wa3hlk8ti8', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-la0vdzv9uvl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-la0vdzv9uvl', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jl5tpxzjszr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jl5tpxzjszr', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gsi14jkahbd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gsi14jkahbd', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-am82tm8lmei').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-am82tm8lmei', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5w7n1cjwwpw').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5w7n1cjwwpw', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-brsu1pn075m').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-brsu1pn075m', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-24nxmeyacbx').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-24nxmeyacbx', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-y6w9lyznjr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-y6w9lyznjr', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-str730mfkci').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-str730mfkci', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-k7pu7nahwc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-k7pu7nahwc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-o3rdzzid6is').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-o3rdzzid6is', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tt9oypnb57i').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tt9oypnb57i', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-w0k640g2u59').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-w0k640g2u59', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vl7kftzm2fi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vl7kftzm2fi', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-u3klbjpjm8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-u3klbjpjm8', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6r7nia2eryk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6r7nia2eryk', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-kr4mcv03wm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kr4mcv03wm', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-dso96dmzolh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-dso96dmzolh', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-05pqca6hjcz2').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-05pqca6hjcz2', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7qxw3s06926').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7qxw3s06926', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-b07nsek8p9j').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-b07nsek8p9j', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-778evdrbbm6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-778evdrbbm6', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-pd9ne5d5i0b').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pd9ne5d5i0b', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-89lacnyzzbb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-89lacnyzzbb', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qpe8rbqw3va').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qpe8rbqw3va', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-65ck4dbzzha').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-65ck4dbzzha', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-lpdrk9g0ae').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lpdrk9g0ae', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1maynbgmb2b').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1maynbgmb2b', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-v5a6p6oj94f').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-v5a6p6oj94f', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-62m5u1oeo3c').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-62m5u1oeo3c', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tobuyzzhfi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tobuyzzhfi', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7yatpq2ou1k').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7yatpq2ou1k', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3lrzr10lug1').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3lrzr10lug1', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-attpcu2tqiu').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-attpcu2tqiu', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-g9h7g9oj116').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-g9h7g9oj116', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-enbb1cs3mg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-enbb1cs3mg', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-twf0fm4lmy').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-twf0fm4lmy', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-nn2izkgww7q').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-nn2izkgww7q', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-uk5viyl7c9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-uk5viyl7c9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zddgivshicd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zddgivshicd', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-kkmz2ld48y').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kkmz2ld48y', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-lf5t2deyb1s').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lf5t2deyb1s', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-h4694wt5xb7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-h4694wt5xb7', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-oz3q6bad4l').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-oz3q6bad4l', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fg5kmqatszg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fg5kmqatszg', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-uhp5yz0rjqm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-uhp5yz0rjqm', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zv0lb050fxa').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zv0lb050fxa', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-e72dmlgygih"]=  window.__ectimmers["ecom-e72dmlgygih"] || {};
var E,$,A,I,j,T;let t=this.$el;if(!t)return;let e=this.isLive;const i=(E=this.settings.disable_auto_close)!=null?E:!1,n=($=this.settings.disable_auto_close__tablet)!=null?$:!1,o=(A=this.settings.disable_auto_close__mobile)!=null?A:!1,s=(I=this.settings.scroll_on_mobile)!=null?I:!1,r=(j=this.settings.disable_effect)!=null?j:!1,a=(T=this.settings.close_all)!=null?T:!1,l=t.querySelector(":scope > .core__group--wrapper > .core__group--items"),c=l?l.querySelectorAll(":scope > .ecom-accordion__item"):[],d=Array.from(c).map(L=>L.querySelector(":scope > .ecom-accordion__title")).filter(Boolean);function m(L){const O=L.getBoundingClientRect();return O.top>=0&&O.left>=0&&O.bottom<=(window.innerHeight||document.documentElement.clientHeight)&&O.right<=(window.innerWidth||document.documentElement.clientWidth)}function g(){return window.EComposer.TEMPLATE_ID?window.screen.width:window.innerWidth}function _(L){return o&&L<768||n&&L>767&&L<1025||i&&L>1024}function b(L){if(!L)return;const O=L.style.transition;L.style.transition="none",L.style.height="auto";const B=L.scrollHeight;L.style.height="0px",L.offsetHeight,L.style.transition=O,requestAnimationFrame(()=>{const N=r?"auto":e?B+"px":"auto";L.style.height=N})}function y(L){L.classList.remove("ecom-item-active");const O=L.querySelector(":scope > .ecom-accordion__body");O&&(r||(O.style.height=O.scrollHeight+"px",O.offsetHeight),requestAnimationFrame(()=>{O.style.height="0px"}))}function v(L){let O=0;if(L.offsetParent)do O+=L.offsetTop;while(L=L.offsetParent);return O}function w(L){const O=Math.max(0,L),B=window.pageYOffset||document.documentElement.scrollTop,N=O-B;if(N===0)return;const Z=300;let U=null;function G(oe){U||(U=oe);const se=Math.min((oe-U)/Z,1),Y=se<.5?2*se*se:1-Math.pow(-2*se+2,2)/2;window.scrollTo(0,B+N*Y),se<1&&window.requestAnimationFrame(G)}window.requestAnimationFrame(G)}function k(L){w(v(L)-100)}function S(L,O=!1){L.forEach((B,N)=>{const Z=B.parentNode,U=Z.querySelector(":scope > .ecom-accordion__body");!r&&U&&U.classList.add("ecom-effect-accodion");const G=Z.classList.contains("ecom-item-active");U&&!a&&(O&&N===0||G)&&requestAnimationFrame(()=>{U.style.height=U.scrollHeight+"px"}),B.onclick=function(oe){var le,me;if(oe.preventDefault(),!e){window.dispatchEvent(new window.Event("renderScroll"));return}const se=g(),Y=this.parentNode,de=Y.parentNode,ge=de.querySelectorAll(":scope > .ecom-accordion__item"),ce=Array.from(ge).map(fe=>fe.querySelector(":scope > .ecom-accordion__title")).filter(Boolean),te=Y.querySelector(":scope > .ecom-accordion__body");Y.classList&&Y.classList.remove("ecom-item-group-init");const q=this.classList.contains("ecom-item-active"),J=_(se);if(q)J?(this.classList.remove("ecom-item-active"),Y.classList.remove("ecom-item-active"),y(Y)):(ge.forEach(y),ce.forEach(fe=>fe.classList.remove("ecom-item-active")));else{J||(ge.forEach(y),ce.forEach(Te=>Te.classList.remove("ecom-item-active"))),B.classList.add("ecom-item-active"),Y.classList.add("ecom-item-active");let fe=Y.closest(".ecom-accordion__body");for(;fe;)fe.style.height="auto",fe=(me=(le=fe.parentElement)==null?void 0:le.closest)==null?void 0:me.call(le,".ecom-accordion__body");!r&&te&&te.classList.add("ecom-effect-accodion"),b(te)}window.dispatchEvent(new window.Event("renderScroll"));const X=this,ue=s||se>1024;function K(){window.dispatchEvent(new window.Event("renderScroll")),ue&&!m(X)&&k(X)}if(ue&&!r){let fe;const Te=function(ze){ze.propertyName==="height"&&(clearTimeout(fe),fe=setTimeout(()=>{de.removeEventListener("transitionend",Te),K()},50))};de.addEventListener("transitionend",Te),setTimeout(()=>{de.removeEventListener("transitionend",Te),K()},600)}else requestAnimationFrame(()=>{setTimeout(K,100)})}})}S(d,!0),a||requestAnimationFrame(()=>{const L=t.querySelector(".ecom-item-group-init");L&&L.classList.remove("ecom-item-group-init")});function z(){const L=window.location.hash;if(L){const O=t.querySelector(`[data-target="${L}"]`);if(O){O.click(),O.dispatchEvent(new MouseEvent("mouseover",{bubbles:!0,cancelable:!0,view:window}));const Z=O.getBoundingClientRect().top+window.pageYOffset-window.innerHeight/2;w(Z)}}}requestAnimationFrame(()=>{setTimeout(z,100)}),window.addEventListener("resize",()=>S(d)),window.addEventListener("hashchange",z,!1)

                    });
                    
                        document.querySelectorAll('.ecom-e72dmlgygih').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-e72dmlgygih', settings: {"disable_auto_close":false,"disable_effect":false,"close_all":true},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-2mvhf67tnua"]=  window.__ectimmers["ecom-2mvhf67tnua"] || {};
if(!this.$el)return!1;const t=this.$el;this.settings.animation&&function(i){if(!t)return;const n=t.querySelector(".ecom__element--button");if(!n)return;let o=parseInt(i.settings.animation_loop_time)*1e3||6e3,s=1e3;window.__ectimmers["ecom-2mvhf67tnua"]["1cxj115o9"] = setInterval(function(){n.classList.add("animated"),setTimeout(function(){n.classList.remove("animated")},s)},o)}(this);var e=t.querySelector(".ecom__element--button");this.isLive&&e&&e.dataset.ecTrackingId&&e.addEventListener("click",function(i){if(window.Shopify&&window.Shopify.analytics){i.preventDefault();let n=window.EComposer.PAGE||window.EComposer.TEMPLATE||window.EComposer.SECTION||window.EComposer.BLOCK||{};const o=Object.assign({button_id:e.id,tracking_id:e.dataset.ecTrackingId},n);try{Shopify.analytics.publish("ec_custom_events",o)}catch(a){console.error("[EC Tracking] Error publishing analytics event:",a)}const s=e.getAttribute("href"),r=e.getAttribute("target");s&&s!=="#"&&s!=="javascript:void(0)"&&(r==="_blank"?window.open(s,"_blank"):setTimeout(function(){window.location.href=s},300))}},{once:!0}),this.isLive&&e&&e.dataset.eventTrackingFb&&e.addEventListener("click",function(i){window.fbq&&window.fbq("track",`${e.dataset.eventTrackingFb}`)},{once:!0})

                    });
                    
                        document.querySelectorAll('.ecom-2mvhf67tnua').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2mvhf67tnua', settings: {"animation":false},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}